<template>
    <div
        class="external-activity--footer"
        v-html="activity.footer"
        v-if="activity.footer && activity.footer.length > 10"
    ></div>
</template>
<script>
    export default {
        props: ['activity'],
    }
</script>
